import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { type ControllerRenderProps } from 'react-hook-form/dist/types/controller';

import { Control, ControlOuterProps } from '../Control';
import { TextInput, TextInputProps } from '../TextInput';

type FormTextInputProps = ControlOuterProps &
  Omit<TextInputProps, 'state' | keyof ControllerRenderProps> & {
    name: string;
  };

export const FormTextInput = forwardRef<HTMLInputElement | HTMLTextAreaElement, FormTextInputProps>((props, ref) => {
  const { name, label, ...textInputProps } = props;

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <Control label={label} error={fieldState.error?.message}>
          <TextInput state={fieldState.invalid ? 'error' : 'default'} {...(textInputProps as any)} {...field} />
        </Control>
      )}
    />
  );
});

FormTextInput.displayName = 'FormTextInput';
